import { Component, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpHeaders } from '@angular/common/http';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PortfolioAccountAssignmentGridLayoutService } from '@irb/irb-create-portfolio/portfolio-account-assignment-dialog/portfolio-account-assignment.grid-layout.service';
import { IAccount, AccountName, IUnassignedAccountsRequest, IUnassignedAccountsResponse } from '@irb/irb-clients/irb-clients.model';
import { UnAssignedAccountService } from '@irb/irb-clients/unassigned/unassigned-account-service';
import { AppService } from '@irb/app.service';
import { IrbCreatePortfolioEvents } from '@irb/irb-common/events';
import { IrbCreatePortfolioService } from '@irb/irb-create-portfolio/irb-create-portfolio.service';
import { IUserDetails } from '@irb/app.model';
import { SelectAllGridParent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';

@Component({ standalone: false,
  selector: 'irb-portfolio-account-assignment-dialog',
  templateUrl: './portfolio-account-assignment-dialog.component.html',
  styleUrls: ['./portfolio-account-assignment-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortfolioAccountAssignmentDialogComponent implements OnDestroy, SelectAllGridParent {  
  grid: any;
  params: any;
  gridOptions: any;
  unAssignedAccounts: IAccount[];
  footerContent: string;
  portfolioName: string;
  portfolioId: number;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  totalCount: number;
  gridRowCount: number;
  private userDetails: IUserDetails;
  uniqueField: string = 'id';
  totalRecordsFromServer: number;
  totalSelectCount: number = 0;
  isSelectedAll: boolean = false;
  finishButtonCallback: Function;
  isAltWorkflow: boolean;
  headerCheckBoxState: string = "unchecked";
  deselectedFromSelectAllRecords: Array<any> = [];
  disableActionBtn: boolean = false;
  accountNumberList: any;
  accountName: any;
  masterNumberList: any;
  accountNameList:any;
  isUiTest = false;
  frameworkComponents: any;
  selectedRowsMap: Map<string, any> = new Map<string, any>();

  constructor(
    public dialogRef: MatDialogRef<PortfolioAccountAssignmentDialogComponent>,
    private gls: PortfolioAccountAssignmentGridLayoutService,
    private uas: UnAssignedAccountService,
    private cdr: ChangeDetectorRef,
    public as: AppService,
    private cps: IrbCreatePortfolioService,
    private ats: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any) {
      this.portfolioName = this.mdd.portfolioName;
      this.portfolioId = this.mdd.portfolioId;
      this.isAltWorkflow = this.mdd.isAltWorkflow || false;
      this.finishButtonCallback = this.mdd.finishButtonCallback || this.showPortfolioImportHoldingsDialog;
      
      this.gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: this.gls.getColumnDefs(this),        
        floatingFilter: true,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No unassigned accounts.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple',
        onSortChanged: () => {
          this.setDatasource();
        },
        suppressHorizontalScroll: true
      };
      
      this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.params = params; //TODO: fix this dependency for irb-custom-header
    this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    this.getmasterNumberList();
    
    this.as.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if(typeof data !== "undefined") {
        this.userDetails = data as IUserDetails;
        this.cps.getUnAssignedAccountCount().pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
          this.totalCount = data.responseData.totalCount;
          this.updateGridFooter();
        });
      }
    });
  }

  setDatasource() {
      return {
          getRows: (params: any) => {
            const filterKeys = [];
            const values:any = [];
            
            for(const key in params.request.filterModel) {
              filterKeys.push(key + "=" + params.request.filterModel[key].filter);
            }
            
            this.uas.getUnAssignedAccounts(params, filterKeys.join("&"), false).pipe(takeUntil(this.destroyed$)).subscribe(data => {
              this.unAssignedAccounts = <IAccount[]> data.body;
              params.success({ rowData: this.unAssignedAccounts });
              this.getGridRowCount(data.headers);

              // window.setTimeout(() => {
              //   if (this.grid && this.grid.api) {
              //     this.grid.api.sizeColumnsToFit();
              //   }
              // });
            });
          }
      };
  }

  getmasterNumberList() {
    this.uas.getComboDropDownValues('masterAccount').subscribe((res: string[]) => {
      this.setFilterValues('masterAccount', res);
    });
  }

  getUnassignedAccountNumber(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
    if(str.length > 0) {
      this.uas.paramsForAcctNum = str;
      this.uas.getUnassignedAccountNumber().subscribe((res: Array<AccountName>) => {
        d.set(res);
      });  
    }
  }

  getUnassignedAccountName(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
    if(str.length > 0) {
      this.uas.paramsForAcctName = str;
      this.uas.getUnassignedAccountName().subscribe((res: Array<AccountName>) => {
        const a: AccountName[] = [];
        
        //group items by account name
        res.forEach((item: AccountName) => {
          let target = a.find((x: AccountName) => x.name == item.name);

          if(target) {
            let b = target.value.toString().split(",");
            b.push(item.value);
            target.value = b.join(",");
          } else {
            a.push(item);
        }
        });

        d.set(a.filter((x: AccountName) => x.name.toLowerCase().includes(str.toLowerCase())));
      });
    }
  }

  setFilterValues(fieldName: string, setValuesList: string[]) {
    switch (fieldName) {
      case 'masterAccount':
        this.masterNumberList = setValuesList;
    }

    this.grid.api.getColumnFilterInstance(fieldName).then((f:any) => {
          f.refreshFilterValues();
    });    
  }

  clearAllFilters() {
    if (this.grid && this.grid.api) {
      this.grid.api.setFilterModel(null);
      this.grid.api.refreshToolPanel();
    }
  }

  private getGridRowCount(headers: HttpHeaders) {
    const r = headers.get('Filter-Count');
    const lengthOfContentRange = r ? r.trim().length : 0;
    const indexOfSlash = r ? r.toString().indexOf('/') : 0;
    this.gridRowCount = r ? parseInt(r.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
    this.totalRecordsFromServer = this.gridRowCount;
    this.updateGridFooter();
  }

  updateGridFooter() {
    if(this.gridRowCount && this.totalCount) {
      this.footerContent = "&lt;strong&gt;" + this.gridRowCount + "&lt;/strong&gt;&nbsp;of " + this.totalCount + " unassigned accounts displayed for SAC username \"" + this.userDetails.userID + "\"";
      this.cdr.detectChanges();
    }
  }

  enableDisableBtns() {
    setTimeout(() => {
      this.totalSelectCount = (this.isSelectedAll) ? this.gridRowCount - this.deselectedFromSelectAllRecords.length : this.selectedRowsMap.size;
      this.cdr.detectChanges();
    }, 200);
  }

  callFinishButtonCallback() {
    this.ats.trackClickEvent("lc_newport_assign_account");

    if (this.mdd.finishButtonCallback) {
      if (this.grid && this.grid.api)
        this.finishButtonCallback(this.portfolioId, this.grid.api.getSelectedRows());
      this.close();
    } else {
      this.showPortfolioImportHoldingsDialog();
    }
  }

  showPortfolioImportHoldingsDialog() {
    this.close();
    this.uas.getAccountsToBeProcessed(this.getUnassignedAccountsRequest()).subscribe((data: IUnassignedAccountsResponse) => {
      this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS, {
        portfolioName: this.portfolioName,
        portfolioId: this.portfolioId,
        portfolioAccounts:  data.accountDetails
      });
    });
  }

  getUnassignedAccountsRequest(): IUnassignedAccountsRequest {
    const r = {
      isSelectAll: this.isSelectedAll,
      showHiddenAccounts: false
    } as IUnassignedAccountsRequest;

    if (this.isSelectedAll) {
      r.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        r.deselectedIds.push(node.id);
      });
    } else {
      r.accountIds = [];
      this.selectedRowsMap.forEach((item: any) => {
        r.accountIds.push(item.id);
      });
    }

    return r;
  }
}
